import React, {useEffect} from 'react';

import Icon from '../../../../../elements/icons/Icon';
import styles from './ActiveFilterButton.module.scss';
import useAnimatedVisibility from '../../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';

const ActiveFilterButton = props => {
    const {className = '', event, filterParams, children, visible = true, title, onClick, onUnmount} = props,
        {visible: isVisible, mounted, showing, hiding, onTransitionEnd} = useAnimatedVisibility({visible});

    useEffect(() => {
        if (!mounted && onUnmount) {
            onUnmount();
        }
    }, [mounted]);

    if (!mounted) return null;

    return (
        <button
            className={[styles.ActiveFilterButton, className, isVisible ? styles.visible : styles.hidden].join(' ')}
            type="button"
            onClick={onClick}
            onTransitionEnd={onTransitionEnd}
            title={title}>
            <Icon src="/img/reject_icon.png" color={event.settings.primary_color} />
            {children}
        </button>
    );
};

export default ActiveFilterButton;
